import { ReactNode } from 'react'
import styled, { css } from 'styled-components'
import { colors } from 'utils/colors'
import Icon, { IconProps } from '../Icon'

interface Props extends Omit<IconProps, 'icon'> {
  position: 'before' | 'after'
  bg?: keyof typeof colors
  color?: keyof typeof colors
  disabled?: boolean
  icon?: IconProps['icon']
  children?: ReactNode
  onClick?: (e?: React.MouseEvent<HTMLElement>) => void
}

const AddonIcon = ({ position, children, disabled, icon, bg, color, onClick, ...iconProps }: Props) => {
  if (icon) {
    return (
      <AddonContainer disabled={disabled} onClick={onClick} position={position} bg={bg} color={color}>
        <Icon icon={icon} {...iconProps} />
      </AddonContainer>
    )
  }

  if (!children) return null

  return <AddonContainer position={position}>{children}</AddonContainer>
}

export const AddonContainer = styled.div<Props>`
  height: 100%;
  cursor: ${(p) => (p.onClick ? (p.disabled ? 'not-allowed' : 'pointer') : 'default')};
  min-width: 2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${(p) => p.theme.colors.gray5};
  background-color: ${(p) => (p?.bg ? p.theme.colors[p.bg] : p.theme.colors.gray3)};
  border: 1px solid ${(p) => p.theme.colors.gray4};
  padding: 0 1rem;
  ${(p) =>
    p.position === 'before'
      ? css`
          border-radius: 4px 0 0 4px;
          border-right: none;
        `
      : css`
          border-radius: 0 4px 4px 0;
          border-left: none;
        `}

  & svg {
    color: ${(p) => (p?.color ? p.theme.colors[p.color] : p.theme.colors.gray5)};
  }
`

export default AddonIcon
